import React, { useRef, useEffect, useState } from "react";
import {
  getScreenshotCategories,
  getCategoryWiseApps,
} from "../../AxiosRtk/Screenshot";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import useFirebase from "../../../../useFirebase";
import useLangTranslation from "../../../customHooks/languageProvider";
import { setAppData } from "../../AxiosRtk/DashBoard";

const ScreenshotsFilter = ({
  showModal,
  closeModal,
  handleFilterSave,
  filterData,
  setFilterData
}) => {
  const { user } = useSelector(({ auth }) => auth);
  const { getLangTranslation } = useLangTranslation();
  const { getCollectionData } = useFirebase();
  const [categories, setCategories] = useState();
  const { selectedDeviceData, appData } = useSelector(({ dashboard }) => dashboard);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState();
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [appIds, setAppIds] = useState([]);
  const dispatch = useDispatch();
  // const [appData, setAppData] = useState(null);

  const currentPathname = window?.location?.pathname;

  useEffect(() => {
    if (selectedDeviceData) {
      getCategories(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedDeviceData && showModal) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData, showModal]);

  function getCategories(deviceId) {
    const obj = {
      userId: user?.ID,
      deviceId: deviceId,
    };
    getScreenshotCategories(obj)
      .then((res) => {
        setCategories(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }
  function getApps() {
    const obj = {
      // categoryId: [1, 2, 3, 5, 4, 6, 7, 56, 548, 17, 18, 547, 19, 20, 21, 22, 563, 38, 24, 25, 26],
      categoryId: [selectedCategoryIds],
      deviceId: selectedDeviceData?.ID,
    };
    getCategoryWiseApps(obj)
      .then((res) => {
        dispatch(setAppData(res?.data?.result));
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }
  useEffect(() => {
    if (selectedCategoryIds?.length > 0 && selectedDeviceData) {
      getApps();
    }
  }, [selectedCategoryIds]);

  useEffect(() => {
    if (filterData) {
      // console.log(filterData)
      setSelectedCategoryIds(filterData?.selectedCategoryIds);
      setAppIds(filterData?.appIds);
    }
  }, [showModal, filterData]);
  const handleCheckboxChange = (categoryId) => {
    const updatedSelectedCategoryIds = selectedCategoryIds?.includes(categoryId)
      ? selectedCategoryIds?.filter((id) => id !== categoryId) // Remove the category ID if already selected
      : [...selectedCategoryIds, categoryId]; // Add the category ID if not already selected
    setSelectedCategoryIds(updatedSelectedCategoryIds);
    // console.log(updatedSelectedCategoryIds);
  };
  const handleAppCheckbox = (appId) => {
    // Check if the package name is already in the selectedPackages array
    const index = appIds?.indexOf(appId);
    if (index === -1) {
      // If not present, add it to the array
      setAppIds([...appIds, appId]);
    } else {
      // If present, remove it from the array
      const updateAppIds = [...appIds];
      updateAppIds.splice(index, 1);
      setAppIds(updateAppIds);
    }
  };

  const handleSave = () => {
    // console.log(selectedPackages);
    setFilterData({ appIds });
    closeModal();
  };
  // Function to clear all checkboxes
  const handleClearAll = () => {
    setSelectedPackages([]);
    setSelectedCategoryIds([]);
  };
  return (
    <>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900 text-uppercase">{getLangTranslation("SCREENSHOT_HITORY_FILTER_KEYWORD", "Kewword Filters")}</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="modal-body">
            <p className="text-small text-gray text-uppercase mb-3 mt-6">
              {getLangTranslation("SCREENSHOT_HITORY_FILTER_CATEGORIES", "Categories")}
            </p>
            {categories?.map((item) => (
              <div
                key={item?.ID}
                className="d-flex align-items-center gap-2 mb-3"
              >
                <h6 className="text-blue-900 mb-0">{item?.Name}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={item?.ID}
                  id={`category_${item?.ID}`}
                  onChange={() => handleCheckboxChange(item?.ID)}
                  checked={selectedCategoryIds?.includes(item?.ID)}
                />
              </div>
            ))}
           
            <p className="text-small text-gray text-uppercase mb-3">{getLangTranslation("LABEL_BY_APP", "BY APP")}</p>
            {appData?.map((item) => (
              <div
                key={item?.appId}
                className="d-flex align-items-center gap-2 mb-3"
              >
                <div className="icon-wrap icon-sm border-0 p-0">
                  <img src={item?.image} alt="" />
                </div>
                <h6 className="text-blue-900 mb-0">{item?.appName}</h6>
                <input
                  className="form-check-input ms-auto"
                  type="checkbox"
                  value={item?.appId}
                  id={`category_${item?.appId}`}
                  onChange={() => handleAppCheckbox(item?.appId)}
                  checked={appIds.includes(item?.appId)}
                />
              </div>
            ))}
            <div className="grid gap-3 mt-6">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={handleClearAll}
              >
                <span className="btn-upper-case">{getLangTranslation("CLEAR_ALL", "Clear all")}</span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={handleSave}
              >
                <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScreenshotsFilter;
